module.exports = __webpack_public_path__ + "static/media/view-contract-button.eb9dcc6e.svg";